import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { ScarcitySpots } from './ScarcitySpots';
const included = ['6 premium volumes', '5 professional bonuses', '30+ planning tools', 'Visual planning maps', 'Case trackers', 'Professional checklists', 'Quick reference cards'];
export function FinalCtaSection() {
  return <section className="bg-navy px-4 py-14 sm:px-6 sm:py-20" data-id="element-107" data-mp="2y66ralmsy282">
      <div className="mx-auto w-full max-w-2xl" data-id="element-108" data-mp="333p26hkdqrip">
        <h2 className="text-center text-[26px] font-black leading-tight tracking-tight text-white sm:text-4xl" data-id="element-109" data-mp="334glaswsiws3">
          Ready to stop organizing every case from scratch?
        </h2>
        <p className="mt-4 text-center text-[14.5px] text-white/80 sm:text-lg" data-id="element-110" data-mp="3cujr5tp0g57u">
          Start building a structured blueprint for your aligner cases.
        </p>

        <ul className="mt-8 grid grid-cols-1 gap-2 sm:grid-cols-2" data-id="element-111" data-mp="2kd7a8f7dfzye">
          {included.map(item => <li key={item} className="flex items-center gap-2.5 rounded-xl border border-white/15 bg-white/5 px-3.5 py-3" data-id="element-112" data-mp="2dcjjjffz6h0p">
              <CheckIcon className="h-4 w-4 shrink-0 text-sky" strokeWidth={3} aria-hidden="true" data-id="element-113" data-mp="28f9n3fu6553d" />
              <span className="text-[13px] font-bold text-white sm:text-sm" data-id="element-114" data-mp="1ymccrwzbymfu">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="mt-9 text-center" data-id="element-115" data-mp="1pmpbrcaijinb">
          <p className="text-[68px] font-black leading-none text-sky sm:text-8xl" data-id="element-116" data-mp="1pkunbo0198eh">
            $27
          </p>
          <p className="mt-3 text-[11.5px] font-extrabold uppercase tracking-[0.14em] text-white/75" data-id="element-117" data-mp="1knl08f0498tt">
            One-time payment · Instant digital access · Lifetime access · 7-day
            guarantee
          </p>
        </div>

        <div className="mx-auto mt-7 max-w-md" data-id="element-118" data-mp="3a2irp8s7rdir">
          <CtaButton variant="onDark" label="Get Aligner Treatment Blueprint™" subLabel="Automatic currency conversion to your local currency" data-id="element-119" data-mp="3a2sj90swpsqk" />
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-120" data-mp="1d5efso5dh2i1">
          <ScarcitySpots tone="dark" data-id="element-121" data-mp="yf78n4ktf5wn" />
        </div>

        <div className="mt-9" data-id="element-122" data-mp="ygqowv6h1gyf">
          <Countdown tone="dark" data-id="element-123" data-mp="13e0au0unjahi" />
        </div>
      </div>
    </section>;
}